import { Money } from '__generated__/types';
import { PaymentStateType, Validity } from 'interfaces';
import { PayoutQuery } from 'utils/graphql/queries/__generated__/payout';

import { IncomingInvoiceStateEnum } from './incomingInvoice';

export enum PayoutState {
  Request = 'request',
  Processing = 'processing',
  Completed = 'completed',
  Canceled = 'canceled',
}

interface PayoutSourcePO {
  id: string;
  number: string;
  totalAmountNet?: number;
  totalAmountNetMoney?: Money;
  __typename?: 'ProviderOrder';
}
interface PayoutSourceII {
  id: string;
  creditNote: boolean;
  invoiceNumber?: string | null;
  number?: string;
  state: IncomingInvoiceStateEnum;
  validity: Validity;
  totalAmountBrutto?: number;
  totalAmountBruttoMoney?: Money;
  __typename?: 'IncomingInvoice';
}
interface PayoutSourcePZ {
  id: string;
  number: string;
  amount?: number;
  amountMoney?: Money;
  __typename?: 'Payout';
}

interface PayoutMethodBP {
  id: string;
  number: string;
  amount: number;
  amountMoney: Money;
  transactionId?: string | null;
  paymentDetails?: Record<string, unknown>;
  state: PaymentStateType;
  __typename?: 'BankPayment';
}
interface PayoutMethodPZ {
  id: string;
  number: string;
  amount: number;
  amountMoney: Money;
  source?: PayoutSource;
  state?: PaymentStateType;
  __typename?: 'Payout';
}

export type PayoutSource = PayoutSourcePO | PayoutSourceII | PayoutSourcePZ;
export type PayoutMethod = PayoutMethodBP | PayoutMethodPZ;

export type Payout = PayoutQuery['payout'];
